import { render, staticRenderFns } from "./UserRequired.vue?vue&type=template&id=ec87a5f4&lang=pug&"
import script from "./UserRequired.vue?vue&type=script&lang=ts&"
export * from "./UserRequired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports